<template>
    <div class="monitor-box">
        <div class="box-head">
            <div class="box-head-con">
                <!-- <div> -->
                    <span style="font-size:0.8vw;">监控类型：</span>
                    <el-select v-model="useType" placeholder="请选择" @change="doFilter">
                        <el-option
                        v-for="item in useTypes"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                    <el-input placeholder="请输入监控名称" v-model="name" style="margin-left:1vw;">
                        <el-button slot="append" icon="el-icon-search" @click="doFilter"></el-button>
                    </el-input>
                <!-- </div> -->
                <!-- <div @click="prePageFun" style="width:5vw;height: 100%;display: flex;align-items: center;justify-content: center;">
                    <i class="el-icon-arrow-left"></i>
                    <span :class="curPage==1?'':'disabled'">上一页</span>
                </div>
                <p style="flex:1;"></p>
                <div @click="nextPageFun" style="width:5vw;height: 100%;display: flex;align-items: center;justify-content: center;">
                    <span :class="curPage==total?'':'disabled'">下一页</span>
                    <i class="el-icon-arrow-right"></i>
                </div> -->
            </div>
        </div>
        <div class="box-contain">
            <div class="box-item" v-for="(item,index) in monitorList" :key="index">
                <div class="item-monitor">
                    <div class="loading-mask" >加载中...</div>
                    <iframe  width="100%" height="100%" :src='item.showUrl' style="border: 0;height: 100%;"></iframe>
                </div>
                <div class="item-info">
                    <span v-if="!item.isEditName" class="name nowrap" @dblclick="changeName(item)">{{item.name}}</span>
                    <div v-if="item.isEditName" class="name" style="text-align: left;padding-left:1vh;">
                        <el-input  v-model="item.name" @change="saveName(item)" @clear="refrshName(item)"></el-input>
                        <!-- <el-button type="text" style="margin-left:1vh;" slot="suffix" @click="cancelName(item)">取消</el-button> -->
                    </div>
                    <img v-if="item.type=='1'" src="../../assets/image/gun.png" />
                    <img v-else-if="item.type=='2'" src="../../assets/image/ptz.png" />
                    <span v-if="item.linkType!='3'" style="margin-right: 1vw;cursor: pointer;" @click="toDetail(item.serial,item.channelNo,item.type,item.id)">操作</span>
                </div>
            </div>
        </div>
        <!-- 分页展示 -->
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[3, 6, 12]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalItems"
        ></el-pagination>
    </div>
</template>
<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
export default {
    data(){
        return{
            groupId:'',
            ysToken:'',
            monitorList:[],
            total:0,
            curPage:1,
            currentPage: 1,
            pageSize: 6,
            totalItems: 0,
            monitorType:'1',
            useTypes:[
                // {id:'0',label:'普通监控',value:'1'},
                // {id:'1',label:'塔吊监控',value:'2'},
            ],
            useType:'1', //监控类型
            curCamer:{
                id:'',
                monitorId:'',
                projectId:'',
                name:'',
                serial:'',
                vcode:'',
                channelNo:'',
                type:'',
                useType:'',
            },//当前修改
            nowEdit:false,
            name:'',//监控名称
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        this.getYsToken()
        this.getUseType()
    },
    methods:{
        //获取token
        getYsToken(){
            var that = this
            myHttp.getYsToken({
              projectId: this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    that.ysToken = resp.data.data.accessToken||''
                    that.getDevice()
                }
            })
        },
        //获取类型
        getUseType(){
            var that = this
            myHttp.getDictByType({
                type:'mt_useType'
            }).then(function(resp){
                if (resp.data.code == '200') {
                    that.useTypes = resp.data.data.dictList
                    // that.getData()
                }
            })
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.handleCurrentChange(this.currentPage)
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.currentChangePage()
        },
        // 监控当前页码
        currentChangePage(list) {
            this.getDevice()
        },
        //监听选择
        doFilter(){
            this.getDevice()
        },
        //获取监控摄像头
        getDevice(){
            var that = this
            myHttp.getCameraPageListByProjectId({
                projectId:this.groupId,
                pageNum:this.currentPage,
                pageSize:this.pageSize,
                useType:this.useType,
                name:this.name
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.PageInfo.list||[];
                    console.log(resp,'9999999999')
                    // that.total = resp.data.data.PageInfo.pages||0
                    for(var i=0;i<list.length;i++){
                        if(list[i].linkType=='3'){
                            if(list[i].hardFlag=='1'){
                                list[i].showUrl = '/ie/one.html?ip='+list[i].monitorIp+'&port='+list[i].port2+'&channel='+list[i].channelNo+'&username='+list[i].username+'&psd='+list[i].password
                            }else{
                                list[i].showUrl = '/ie/one.html?ip='+list[i].ip+'&port='+list[i].port2+'&channel='+list[i].channelNo+'&username='+list[i].username+'&psd='+list[i].password
                            }
                        }else{
                            list[i].showUrl = '/monitor/view/one.html?serial='+list[i].serial+'&channel='+list[i].channelNo+'&token='+that.ysToken
                        }
                        list[i].isEditName = false
                    }
                    that.monitorList = list
                    console.log('that.monitorList111',that.monitorList);
                    
                    that.totalItems = resp.data.data.PageInfo.total||0
                }
            })
        },
        //修改名称
        changeName(row){
            row.isEditName = true
            row.oldName = row.name
            // this.curCamer = row
            // delete this.curCamer.createDate
        },
        //取消保存名称
        cancelName(row){
            console.log(new Date().getTime()+'======取消保存名称=========')
            row.name = row.oldName
            row.isEditName = false
            this.nowEdit = false
        },
        //保存名称
        saveName(row){
            console.log(new Date().getTime())
            var that = this
            if(this.nowEdit)return;
            this.nowEdit = true
            if(row.type=='1'){
                //萤石云修改
                myHttp.updateCameraInfo({
                    id : row.id,
                    monitorId : row.monitorId,
                    projectId : row.projectId,
                    name : row.name,
                    serial : row.serial,
                    vcode : row.vcode,
                    channelNo : row.channelNo,
                    type : row.type,
                    useType : row.useType
                }).then(
                    function(resp) {
                        if (resp.data.code == "200") {
                            that.$message.success("修改成功");
                            row.isEditName = false;
                        } else {
                            that.$message.error(resp.data.msg);
                        }
                        that.nowEdit = false
                    },
                    function() {that.nowEdit = false}
                );
            }else{
                //大华修改
                myHttp.updateCameraInfo({
                    id : row.id,
                    monitorId : row.monitorId,
                    projectId : row.projectId,
                    name : row.name,
                    serial : row.serial,
                    vcode : row.vcode,
                    channelNo : row.channelNo,
                    type : row.type,
                    useType : row.useType
                }).then(
                function(resp) {
                    if (resp.data.code == '200') {
                        that.$message.success('修改成功')
                        row.isEditName = false;
                    } else {
                        that.$message.error(resp.data.msg)
                    }
                    that.nowEdit = false
                },
                function() {that.nowEdit = false}
                )
            }
        },
        //上一页
        prePageFun(){
            if(this.curPage==1||this.curPage<1){
                this.$message('当前已经是第一页');
            }else{
                this.curPage--
                this.getDevice()
            }
        },
        //下一页
        nextPageFun(){
            if(this.curPage==this.total||this.curPage>this.total){
                this.$message('当前已经是最后一页');
            }else{
                this.curPage++
                this.getDevice()
            }
        },
        //跳转单个视频
        toDetail(id,channel,type,mid){
            this.$router.push({path:'/monitCtl/'+id+'/'+channel+'/'+type+'/'+mid})
        },
    },
    destroyed(){
        
    },
}
</script>
<style scoped>
    .monitor-box{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .box-head{
        width:100%;
        height: 7vh;
        position: relative;
        padding:0.5vh 1vh;
    }
    .box-head-con{
        background: #fff;
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        /* justify-content: space-between; */
        align-content: center;
        align-items: center;
        padding: 0 1vw;
        justify-content: flex-start;
    }
    .box-contain{
        width: 100%;
        height: calc( 100% - 13vh );
        position: relative;
        display: flex;
        flex-wrap: wrap;
        padding: 0 0.5vh;
        overflow: auto;
        align-content: flex-start;
    }
    .box-item{
        width:33.33%;
        height: 50%;
        position: relative;
        padding: 0 0.5vh 1vh;
    }
    .item-monitor{
        width: 100%;
        height: calc( 100% - 5vh );
        position: relative;
        background: #fff;
    }
    .loading-mask{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        /* background: #000; */
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        z-index: 1;
    }
    .item-monitor iframe{
        position: relative;
        z-index: 2;
    }
    .item-info{
        width: 100%;
        height: 5vh;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: space-around;
        background: #fff;
    }
    .item-info .name{
        flex:1;
        text-align: center;
        
    }
    .item-info img{
        width:1.5vw;
        height: auto;
        position: relative;
        margin: 0 1vw;
    }
    .disabled{
        color:#409EFF;
        cursor: pointer;
    }
    /* .el-pagination{
        height: 6vh;
    } */
</style>
<style>
    @import '../../assets/css/common.css'
</style>